import React, { Component } from 'react';
import Banner from '../../components/Banner';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { URL } from '../../components/BackendApi';
import PageMeta, { plainText } from '../../components/PageMeta';
import { Link } from 'react-router-dom';
import './style.scss';

class CourseDetailPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      course: null,
      loading: true,
      error: null,
      submitted: false,
      submitting: false,
      submitError: null,
      // Form fields
      customerType: 'individual',
      businessId: '',
      companyName: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      email: '',
      phone: '',
      address: '',
      postalCode: '',
      city: '',
      newsletterOptIn: '',
      paymentMethod: 'card',
      invoiceType: '',
      invoiceReference: '',
      invoiceAddress: '',
      eInvoiceAddress: '',
      brokerId: '',
      termsAccepted: false,
      discountCode: '',
      discountPercent: null,
      discountError: null,
      discountApplied: false,
      validatingCode: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleValidateCode = this.handleValidateCode.bind(this);
  }

  componentDidMount() {
    const slug = this.props.match.params.slug;
    fetch(`${URL}/courses/public/course/${slug}`)
      .then(response => {
        if (!response.ok) throw new Error('Course not found');
        return response.json();
      })
      .then(data => {
        this.setState({ course: data, loading: false });
      })
      .catch(error => {
        console.error('Error fetching course:', error);
        this.setState({ error: 'Koulutusta ei l\u00f6ytynyt.', loading: false });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    const updates = { [name]: value };

    // Reset dependent fields
    if (name === 'customerType' && value === 'individual') {
      updates.paymentMethod = 'card';
      updates.invoiceType = '';
      updates.invoiceReference = '';
      updates.invoiceAddress = '';
      updates.eInvoiceAddress = '';
      updates.brokerId = '';
      updates.businessId = '';
      updates.companyName = '';
    }
    if (name === 'paymentMethod' && value === 'card') {
      updates.invoiceType = '';
      updates.invoiceReference = '';
      updates.invoiceAddress = '';
      updates.eInvoiceAddress = '';
      updates.brokerId = '';
    }

    this.setState(updates);
  }

  handleValidateCode() {
    const code = this.state.discountCode.trim();
    if (!code) return;

    this.setState({ validatingCode: true, discountError: null });

    fetch(`${URL}/courses/public/validate_code?code=${encodeURIComponent(code)}`)
      .then(response => response.json())
      .then(data => {
        if (data.valid) {
          this.setState({
            discountPercent: data.discount_percent,
            discountApplied: true,
            discountError: null,
            validatingCode: false
          });
        } else {
          this.setState({
            discountPercent: null,
            discountApplied: false,
            discountError: data.message || 'Etukoodi ei kelpaa',
            validatingCode: false
          });
        }
      })
      .catch(() => {
        this.setState({
          discountError: 'Virhe koodin tarkistuksessa',
          validatingCode: false
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.newsletterOptIn === '') {
      this.setState({ submitError: 'Valitse kyll\u00e4 tai ei uutiskirjeen tilauksen kohdalla.' });
      return;
    }

    this.setState({ submitting: true, submitError: null });

    const body = {
      course_id: this.state.course.id,
      registration: {
        customer_type: this.state.customerType,
        business_id: this.state.businessId,
        company_name: this.state.companyName,
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        date_of_birth: this.state.dateOfBirth,
        email: this.state.email,
        phone: this.state.phone,
        address: this.state.address,
        postal_code: this.state.postalCode,
        city: this.state.city,
        newsletter_opt_in: this.state.newsletterOptIn === 'yes',
        payment_method: this.state.paymentMethod,
        invoice_type: this.state.invoiceType,
        invoice_reference: this.state.invoiceReference,
        invoice_address: this.state.invoiceAddress,
        e_invoice_address: this.state.eInvoiceAddress,
        broker_id: this.state.brokerId
      },
      discount_code: this.state.discountApplied ? this.state.discountCode.trim() : '',
      accept_url: `${window.location.origin}/koulutus/maksu/onnistui`,
      cancel_url: `${window.location.origin}/koulutus/maksu/peruutettu`
    };

    fetch(`${URL}/courses/public/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(data => {
            throw new Error(data.errors ? data.errors.join(', ') : data.error || 'Registration failed');
          });
        }
        return response.json();
      })
      .then(data => {
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          // Invoice payment or free (100% discount)
          this.setState({ submitted: true, submitting: false });
        }
      })
      .catch(error => {
        console.error('Registration error:', error);
        this.setState({ submitError: error.message, submitting: false });
      });
  }

  render() {
    const { course, loading, error, submitted, submitting, submitError } = this.state;

    if (loading) {
      return (
        <div className="page">
          <Banner><h1>Koulutus</h1></Banner>
          <Container className="p-t-50 p-b-50 text-center">
            <p>Ladataan...</p>
          </Container>
        </div>
      );
    }

    if (error) {
      return (
        <div className="page">
          <Banner><h1>Koulutus</h1></Banner>
          <Container className="p-t-50 p-b-50 text-center">
            <p>{error}</p>
          </Container>
        </div>
      );
    }

    if (submitted) {
      return (
        <div className="page">
          <Banner><h1>{course.name}</h1></Banner>
          <Container className="p-t-50 p-b-50 text-center">
            <h2>Kiitos ilmoittautumisesta!</h2>
            <p>Ilmoittautumisesi on vastaanotettu.</p>
          </Container>
        </div>
      );
    }

    return (
      <div className="page course-detail-page">
        <PageMeta
          title={`${course.name} ${course.city} ${course.course_date}`}
          description={plainText(course.description_html) || `${course.name}, ${course.city} ${course.course_date}. Ilmoittaudu koulutukseen verkossa.`}
        />
        <Banner><h1>{course.name}</h1></Banner>

        <Container className="p-t-50 p-b-50">
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              {/* Course info */}
              <div className="course-detail-page__info">
                <h2>{course.name}</h2>
                <div className="course-detail-page__meta">
                  <p><strong>P&auml;iv&auml;m&auml;&auml;r&auml;:</strong> {course.course_date}</p>
                  <p><strong>Aika:</strong> {course.start_time} - {course.end_time}</p>
                  <p><strong>Paikka:</strong> {course.venue}{course.address ? `, ${course.address}` : ''}{course.postal_code ? `, ${course.postal_code}` : ''}</p>
                  <p><strong>Hinta:</strong> {course.price_euros.toFixed(0)} &euro; (sis. alv 25,5 %)</p>
                  {course.instructor_name && (
                    <p><strong>Kouluttaja:</strong> {course.instructor_name}</p>
                  )}
                  <p><strong>Paikkoja j&auml;ljell&auml;:</strong> {course.spots_remaining} / {course.max_attendees}</p>
                </div>

                {course.description_html && (
                  <div
                    className="course-detail-page__description"
                    dangerouslySetInnerHTML={{ __html: course.description_html }}
                  />
                )}
              </div>

              {course.registration_open === false ? (
                <div className="course-detail-page__full">
                  <h3>Ilmoittautuminen on p&auml;&auml;ttynyt</h3>
                  <p>T&auml;h&auml;n koulutukseen ei voi en&auml;&auml; ilmoittautua. Katso muut tulevat koulutukset <a href="/koulutus">koulutuskalenterista</a>.</p>
                </div>
              ) : course.full ? (
                <div className="course-detail-page__full">
                  <h3>Koulutus on t&auml;ynn&auml;</h3>
                  <p>Valitettavasti t&auml;h&auml;n koulutukseen ei ole en&auml;&auml; vapaita paikkoja.</p>
                </div>
              ) : (
                <>
                  <hr />
                  <h3>Ilmoittautuminen</h3>

                  {submitError && (
                    <div className="course-detail-page__error">{submitError}</div>
                  )}

                  <Form onSubmit={this.handleSubmit}>
                    {/* Customer type */}
                    <Form.Group>
                      <Form.Label>Asiakas *</Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          id="customerType-individual"
                          label="Yksityishenkilö"
                          name="customerType"
                          value="individual"
                          checked={this.state.customerType === 'individual'}
                          onChange={this.handleChange}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          id="customerType-company"
                          label="Yritys"
                          name="customerType"
                          value="company"
                          checked={this.state.customerType === 'company'}
                          onChange={this.handleChange}
                        />
                      </div>
                    </Form.Group>

                    {/* Company fields */}
                    {this.state.customerType === 'company' && (
                      <>
                        <Form.Group>
                          <Form.Label>Y-tunnus *</Form.Label>
                          <Form.Control
                            type="text"
                            name="businessId"
                            value={this.state.businessId}
                            onChange={this.handleChange}
                            required
                          />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Yrityksen nimi *</Form.Label>
                          <Form.Control
                            type="text"
                            name="companyName"
                            value={this.state.companyName}
                            onChange={this.handleChange}
                            required
                          />
                        </Form.Group>
                      </>
                    )}

                    {/* Personal fields */}
                    <Form.Row>
                      <Form.Group as={Col}>
                        <Form.Label>Etunimi *</Form.Label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          value={this.state.firstName}
                          onChange={this.handleChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label>Sukunimi *</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName"
                          value={this.state.lastName}
                          onChange={this.handleChange}
                          required
                        />
                      </Form.Group>
                    </Form.Row>

                    <Form.Group>
                      <Form.Label>Syntym&auml;aika</Form.Label>
                      <Form.Control
                        type="text"
                        name="dateOfBirth"
                        value={this.state.dateOfBirth}
                        onChange={this.handleChange}
                        placeholder="pp.kk.vvvv"
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>S&auml;hk&ouml;posti *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Puhelinnumero *</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        value={this.state.phone}
                        onChange={this.handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Osoite</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={this.state.address}
                        onChange={this.handleChange}
                      />
                    </Form.Group>

                    <Form.Row>
                      <Form.Group as={Col} md={4}>
                        <Form.Label>Postinumero</Form.Label>
                        <Form.Control
                          type="text"
                          name="postalCode"
                          value={this.state.postalCode}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <Form.Group as={Col} md={8}>
                        <Form.Label>Kaupunki</Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          value={this.state.city}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                    </Form.Row>

                    {/* Newsletter */}
                    <Form.Group>
                      <Form.Label>
                        Haluan vastaanottaa Nordic Security Alliance yhti&ouml;iden suoramarkkinointia
                        liittyen Nordic Security Alliance yhti&ouml;iden toimintaan, palveluihin, koulutuksiin
                        ja ty&ouml;paikkoihin *
                      </Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          id="newsletterOptIn-yes"
                          label="Kyllä"
                          name="newsletterOptIn"
                          value="yes"
                          checked={this.state.newsletterOptIn === 'yes'}
                          onChange={this.handleChange}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          id="newsletterOptIn-no"
                          label="Ei"
                          name="newsletterOptIn"
                          value="no"
                          checked={this.state.newsletterOptIn === 'no'}
                          onChange={this.handleChange}
                        />
                      </div>
                    </Form.Group>

                    {/* Discount code */}
                    <Form.Group>
                      <Form.Label>Etukoodi</Form.Label>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <Form.Control
                          type="text"
                          name="discountCode"
                          value={this.state.discountCode}
                          onChange={(e) => this.setState({ discountCode: e.target.value, discountError: null })}
                          style={{ flex: 1, textTransform: 'uppercase' }}
                          disabled={this.state.discountApplied}
                        />
                        {this.state.discountApplied ? (
                          <button
                            type="button"
                            className="btn-standard"
                            onClick={() => this.setState({ discountApplied: false, discountPercent: null, discountCode: '' })}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            Poista
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn-standard"
                            onClick={this.handleValidateCode}
                            disabled={this.state.validatingCode || !this.state.discountCode.trim()}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            {this.state.validatingCode ? '...' : 'Käytä'}
                          </button>
                        )}
                      </div>
                      {this.state.discountError && (
                        <div style={{ color: '#c00', marginTop: '4px', fontSize: '0.9em' }}>{this.state.discountError}</div>
                      )}
                      {this.state.discountApplied && (
                        <div style={{ color: '#090', marginTop: '4px', fontSize: '0.9em', fontWeight: 'bold' }}>
                          Etukoodi hyväksytty! Alennus: −{this.state.discountPercent}%
                          (Hinta: {((course.price_euros * (100 - this.state.discountPercent)) / 100).toFixed(0)} €)
                        </div>
                      )}
                    </Form.Group>

                    {/* Payment method */}
                    <Form.Group>
                      <Form.Label>Maksutapa *</Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          id="paymentMethod-card"
                          label="Korttimaksu"
                          name="paymentMethod"
                          value="card"
                          checked={this.state.paymentMethod === 'card'}
                          onChange={this.handleChange}
                        />
                        {this.state.customerType === 'company' && (
                          <Form.Check
                            inline
                            type="radio"
                            id="paymentMethod-invoice"
                            label="Lasku"
                            name="paymentMethod"
                            value="invoice"
                            checked={this.state.paymentMethod === 'invoice'}
                            onChange={this.handleChange}
                          />
                        )}
                      </div>
                    </Form.Group>

                    {/* Invoice fields */}
                    {this.state.paymentMethod === 'invoice' && (
                      <>
                        <Form.Group>
                          <Form.Label>Laskutustapa *</Form.Label>
                          <Form.Control
                            as="select"
                            name="invoiceType"
                            value={this.state.invoiceType}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="">Valitse...</option>
                            <option value="paper">Paperilasku</option>
                            <option value="e-invoice">Verkkolasku</option>
                          </Form.Control>
                        </Form.Group>

                        {this.state.invoiceType === 'paper' && (
                          <Form.Group>
                            <Form.Label>Laskutusosoite *</Form.Label>
                            <Form.Control
                              type="text"
                              name="invoiceAddress"
                              value={this.state.invoiceAddress}
                              onChange={this.handleChange}
                              required
                            />
                          </Form.Group>
                        )}

                        {this.state.invoiceType === 'e-invoice' && (
                          <>
                            <Form.Group>
                              <Form.Label>Verkkolaskuosoite *</Form.Label>
                              <Form.Control
                                type="text"
                                name="eInvoiceAddress"
                                value={this.state.eInvoiceAddress}
                                onChange={this.handleChange}
                                required
                              />
                            </Form.Group>
                            <Form.Group>
                              <Form.Label>Välittäjätunnus *</Form.Label>
                              <Form.Control
                                type="text"
                                name="brokerId"
                                value={this.state.brokerId}
                                onChange={this.handleChange}
                                required
                              />
                            </Form.Group>
                          </>
                        )}

                        <Form.Group>
                          <Form.Label>Viite *</Form.Label>
                          <Form.Control
                            type="text"
                            name="invoiceReference"
                            value={this.state.invoiceReference}
                            onChange={this.handleChange}
                            required
                          />
                        </Form.Group>
                      </>
                    )}

                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id="termsAccepted"
                        name="termsAccepted"
                        checked={this.state.termsAccepted}
                        onChange={(e) => this.setState({ termsAccepted: e.target.checked })}
                        label={
                          <span>
                            Olen tutustunut Nordic Security Alliance Group Oy:n koulutuspalveluiden{' '}
                            <Link to="/koulutus/tilaus-ja-peruutusehdot" target="_blank" rel="noopener noreferrer">
                              tilaus- ja peruutusehtoihin
                            </Link>
                            {' '}ja hyväksyn ne. *
                          </span>
                        }
                        required
                      />
                    </Form.Group>

                    <div className="course-detail-page__submit">
                      <button
                        type="submit"
                        className="btn-standard"
                        disabled={submitting}
                      >
                        {submitting ? 'Lähetetään...' : 'Ilmoittaudu ja maksa'}
                      </button>
                    </div>
                  </Form>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default CourseDetailPage;
